import RulesDeleteDialog from './RulesDeleteDialog';

export { RulesDeleteDialog };
export default RulesDeleteDialog;
